import { Box, TableCell, TableRow, Typography, styled } from "@mui/material"

export const DrawerBox = styled(Box)({
  width: "600px",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  top: "80px",
})

export const DrawerBoxHeading = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: 1,
  borderColor: "divider",
  padding: "0px 40px",
})
export const Heading = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px 40px",
})
export const TypoHeading = styled(Typography)({
  fontSize: "16px",
  fontWeight: "bold",
  padding: "20px 0px",
})

export const GoalHeading = styled(Typography)({
  fontSize: "16px",
  fontWeight: "900",
  padding: "20px 0px",
  color: "#000",
  textTransform: "capitalize",
})

export const ModalHeadingRow = styled(TableRow)({
  backgroundColor: "#3366D6",
  height: "32px",
  position: "sticky",
  top: "0px",
  textAlign: "center",
})

export const ModalHeadingCell = styled(TableCell)({
  color: "#fff",
  fontSize: "13px",
})

export const GoalHeader = styled(Box)({
  width: "100%",
  height: "32px",
  backgroundColor: "#3366D6",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
})

export const GoalHeaderTypo = styled(Box)({
  color: "#fff",
  fontSize: "13px",
  width: "50%",
  display: "flex",
  paddingLeft: "40px",
})

export const BaseBox = styled(Box)({
  width: "100%",
  height: "85px",
  display: "flex",
  padding: " 0px 40px ",
})

export const SubBaseBox = styled(Box)({
  width: "200px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
})

export const SubBaseBoxText = styled(Typography)({
  color: "#000000",
  fontSize: "10px",
})

export const SubBaseDisplayBox = styled(Box)({
  width: "134px",
  height: "40px",
  border: "1px solid #BEBEBE",
  backgroundColor: "#F7F7F7",
  color: "#000000",
  fontSize: "14px",
  display: "flex",
  alignItems: "center",
  paddingLeft: "13px",
})

export const GoalsBox = styled(Box)({
  width: "100%",
  height: "65px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
})

export const EditGoalWrapper = styled(Box)({
  width: "50%",
  height: "45px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
})

export const EditGoalBox = styled(Box)({
  height: "100%",
  minWidth: "130px",
  backgroundColor: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #E4E4E3",
})
export const EditGoalBoxTwo = styled(Box)({
  height: "100%",
  minWidth: "130px",
  backgroundColor: "#F7F7F7",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
})

export const EditGoalBoxMax = styled(Box)({
  height: "100%",
  minWidth: "130px",
  backgroundColor: "#F7F7F7",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  maxWidth: "130px",
})
